import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { RootState } from './types';
import { auth } from './auth';
import { cast } from './cast';
import { castList } from './castList';
import { userData } from './userData';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';
Vue.use(Vuex)

const store: StoreOptions<RootState> = {
  state: {
    isLoading: false,
    errMessage: '',
    infoMessage: ''
  },
  actions: actions,
  mutations: mutations,
  getters: getters,
  modules: {
    auth,
    cast,
    castList,
    userData
  },
  plugins: [createPersistedState({
    paths: ['cast', 'auth', 'userData']
  })],
};

export default new Vuex.Store<RootState>(store);